import type { ReactNode } from 'react';

/** Shared empty state: kicker + message (+ optional action). Same card language as the rest of the admin. */
export function EmptyBlock({
  message,
  kicker = 'NADA POR AQUI',
  action,
}: {
  message: string;
  kicker?: string;
  action?: ReactNode;
}) {
  return (
    <div style={{ padding: '32px 20px', textAlign: 'center' }}>
      <div className="label" style={{ color: 'var(--lv-brand-light)', fontSize: 10 }}>
        {kicker}
      </div>
      <div style={{ marginTop: 6, fontSize: 13, color: 'var(--lv-gray-500)' }}>{message}</div>
      {action && <div style={{ marginTop: 14 }}>{action}</div>}
    </div>
  );
}

/** Table flavour: one full-width row. */
export function EmptyRow({
  colSpan,
  message,
  action,
}: { colSpan: number; message: string; action?: ReactNode }) {
  return (
    <tr>
      <td colSpan={colSpan} style={{ padding: 0 }}>
        <EmptyBlock message={message} action={action} />
      </td>
    </tr>
  );
}

/** Loading placeholder block sized like the number it replaces. */
export function Skeleton({ width = 72, height = 44 }: { width?: number; height?: number }) {
  return (
    <span
      aria-hidden
      style={{
        display: 'inline-block',
        width,
        height,
        background: 'var(--lv-line)',
        verticalAlign: 'middle',
      }}
    />
  );
}
